import React, { useEffect, useState } from 'react'

import CardStats from 'components/Cards/CardStats.js'
import apiService from 'apiService'
import helpers from 'helpers'

export default function HeaderStats() {
    const [todaySales, setTodaySales] = useState(0)
    const [todaySalesDirection, setTodaySalesDirection] = useState('up')
    const [todaySalesPercentage, setTodaySalesPercentage] = useState(0)

    const [todayRealSales, setTodayRealSales] = useState(0)
    const [todayRealSalesDirection, setTodayRealSalesDirection] = useState('up')
    const [todayRealSalesPercentage, setTodayRealSalesPercentage] = useState(0)

    const [todayVatSave, setTodayVatSave] = useState(0)
    const [todayVatSaveDirection, setTodayVatSaveDirection] = useState('up')
    const [todayVatSavePercentage, setTodaySavePercentage] = useState(0)

    const [todayPercentage, setTodayPercentage] = useState(0)
    const [todayPercentageDirection, setTodayPercentageDirection] = useState('up')
    const [todayPercentagePer, setTodayPercentagePer] = useState(0)

    const getTodaySales = () => {
        return apiService.get(`/stats/today-sales`)
    }

    const getYesterdaySales = () => {
        return apiService.get(`/stats/yesterday-sales`)
    }

    const initStats = async () => {
        const todaySales = await getTodaySales()
        const yesterdaySales = await getYesterdaySales()

        initTodaySales(todaySales, yesterdaySales)
        initTodayRealSales(todaySales, yesterdaySales)
        initTodayVatSave(todaySales, yesterdaySales)
        initTodayPercentage(todaySales, yesterdaySales)
    }

    const initTodaySales = (todaySales, yesterdaySales) => {
        setTodaySales(helpers.twoDigitNumber(todaySales.start_sum))

        if (todaySales.start_sum >= yesterdaySales.start_sum) {
            setTodayRealSalesDirection('up')
        } else {
            setTodayRealSalesDirection('down')
        }

        const percentage = (todaySales.start_sum / yesterdaySales.start_sum - 1) * 100
        setTodaySalesPercentage(Math.abs(percentage).toFixed(2))
    }

    const initTodayRealSales = (todaySales, yesterdaySales) => {
        setTodayRealSales(helpers.twoDigitNumber(todaySales.final_sum))

        if (todaySales.final_sum >= yesterdaySales.final_sum) {
            setTodaySalesDirection('up')
        } else {
            setTodaySalesDirection('down')
        }

        const percentage = (todaySales.final_sum / yesterdaySales.final_sum - 1) * 100
        setTodayRealSalesPercentage(Math.abs(percentage).toFixed(2))
    }

    const initTodayVatSave = (todaySales, yesterdaySales) => {
        const vatSave = todaySales.start_vat - todaySales.final_vat
        setTodayVatSave(vatSave.toFixed(2))

        if (todaySales.start_vat - todaySales.final_vat >= yesterdaySales.start_vat - yesterdaySales.final_sum) {
            setTodayVatSaveDirection('up')
        } else {
            setTodayVatSaveDirection('down')
        }

        const percentage = ((todaySales.start_vat - todaySales.final_vat) / (yesterdaySales.start_vat - yesterdaySales.final_vat) - 1) * 100
        console.log(percentage)
        setTodaySavePercentage(Math.abs(percentage).toFixed(2))
    }

    const initTodayPercentage = (todaySales, yesterdaySales) => {
        const todayPercent = (1 - todaySales.final_sum / todaySales.start_sum) * 100
        const yesterdayPerecent = (1 - yesterdaySales.final_sum / yesterdaySales.start_sum) * 100
        setTodayPercentage(todayPercent.toFixed(2))

        setTodayPercentageDirection(todayPercent >= yesterdayPerecent ? 'up' : 'down')

        const percentage = (todayPercent / yesterdayPerecent - 1) * 100
        setTodayPercentagePer(Math.abs(percentage).toFixed(2))
    }

    useEffect(() => {
        initStats()
    }, [])
    return (
        <>
            <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
                <div className="px-4 md:px-10 mx-auto w-full">
                    <div>
                        {window.location.pathname === '/admin/dashboard' && (
                            <>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                        <CardStats statSubtitle="ΠΩΛΗΣΕΙΣ" statTitle={todaySales} statArrow={todaySalesDirection} statPercent={todaySalesPercentage} statDescripiron=" Σε σύγκριση με εχθές" statIconName="fas fa-coins" statIconColor="bg-red-500" />
                                    </div>
                                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                        <CardStats statSubtitle="Τ. ΠΩΛΗΣΕΙΣ" statTitle={todayRealSales} statArrow={todayRealSalesDirection} statPercent={todayRealSalesPercentage} statDescripiron=" Σε σύγκριση με εχθές" statIconName="fas fa-money-bill" statIconColor="bg-orange-500" />
                                    </div>
                                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                        <CardStats statSubtitle="ΩΦΕΛΙΜΟ" statTitle={todayVatSave} statArrow={todayVatSaveDirection} statPercent={todayVatSavePercentage} statDescripiron=" Σε σύγκριση με εχθές" statIconName="fas fa-minus" statIconColor="bg-emerald-500" />
                                    </div>
                                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                        <CardStats statSubtitle="ΠΟΣΟΣΤΟ" statTitle={todayPercentage} statArrow={todayPercentageDirection} statPercent={todayPercentagePer} statDescripiron=" Σε σύγκριση με εχθές" statIconName="fas fa-percent" statIconColor="bg-lightBlue-500" />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}
